<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Performance review</h3>
    <div class="dialog-header__title">
      <img
        class="interview__trash icon"
        src="assets/icons/svg/trash/ion_trash-bin.svg"
        alt="trash"
        (click)="deletePerformance()"
        *ngIf="!isCreate"
      />
    </div>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="performanceReviewForm">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="mb-16 align-items-center d-flex">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="performanceReviewForm"
                [controlName]="'date'"
                [touched]="performanceReviewForm.get('date')!.touched"
                >Date</label
              >
              <div class="date_input">
                <app-datepicker
                  [iconLeft]="true"
                  formControlName="date"
                  [staticPropery]="true"
                  (datepickerOpened)="isDatePickerOpened = $event"
                ></app-datepicker>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('date', performanceReviewForm) &&
                    performanceReviewForm.get('date')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="performanceReviewForm"
                [controlName]="'hr'"
                [touched]="performanceReviewForm.get('hr')!.touched"
                >HR</label
              >
              <div
                class="input-wrapper"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="data.hr"
                  (change)="setHr()"
                  formControlName="hr"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('hr', performanceReviewForm) &&
                    performanceReviewForm.get('hr')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="performanceReviewForm"
                [controlName]="'pm'"
                [touched]="performanceReviewForm.get('pm')!.touched"
                >PM</label
              >
              <div
                class="input-wrapper"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="data.pm"
                  formControlName="pm"
                  (change)="setPm()"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('pm', performanceReviewForm) &&
                    performanceReviewForm.get('pm')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="performanceReviewForm"
                [controlName]="'level'"
                [touched]="performanceReviewForm.get('level')!.touched"
                >New level</label
              >
              <div class="input-wrapper">
                <app-dropdown
                  [items]="data.level"
                  formControlName="level"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('level', performanceReviewForm) &&
                    performanceReviewForm.get('level')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mt-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="performanceReviewForm"
                [controlName]="'status'"
                [touched]="performanceReviewForm.get('status')!.touched"
                >Status</label
              >
              <div class="input-wrapper">
                <app-dropdown
                  [items]="data.statusDropdown"
                  formControlName="status"
                >
                </app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('status', performanceReviewForm) &&
                    performanceReviewForm.get('status')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-7 row input__wrapper">
            <label
              class="label-input col-3"
              appMarkAsterisk
              [formGroup]="performanceReviewForm"
              [controlName]="'comment'"
              [touched]="performanceReviewForm.get('comment')!.touched"
              >Comment</label
            >
            <textarea
              formControlName="comment"
              class="input__basic input__textarea col"
              placeholder=" "
            ></textarea>
            <app-error-field
              [displayError]="
                performanceReviewForm.get('comment')!.hasError('wordCount')
              "
              [errorMessage]="'Max field length = 400 words'"
            ></app-error-field>
          </div>
          <div class="col">
            <button
              *ngIf="!performanceReviewForm.controls['file']?.value"
              class="button button__lightblue"
              (click)="attachLink()"
            >
              Add document
            </button>
            <div class="perfomance">
              <a
                [href]="performanceReviewForm.controls['file'].value"
                target="_blank"
                ><img
                  *ngIf="performanceReviewForm.controls['file']?.value"
                  class="perfomance__attached_doc icon"
                  src="assets/icons/svg/attached_document/normal.svg"
                  alt="link"
              /></a>
              <div class="perfomance__docs">
                <i
                  *ngIf="performanceReviewForm.controls['file']?.value"
                  class="icon-close icon blue"
                  (click)="deleteDocLink()"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancelSave()">
        Cancel
      </button>
    </div>
  </div>
</div>
